import styled, { css } from "styled-components/macro";
import tw from "twin.macro";

const keyFrames = css`
  @keyframes zoomInOut {
    0%,
    100% {
      transform: scale(0.5);
    }
    50% {
      transform: scale(1);
    }
  }
  @keyframes bounceTop {
    0%,
    100% {
      transform: scale(0.5);
    }
    50% {
      transform: scale(1);
    }
  }
`;

export const BgCircles = styled.div`
  ${keyFrames};
  ${tw`fixed top-0 h-full left-1/2 `};

  max-width: 1200px;
  width: calc(100% - 30px);
  transform: translateX(-50%);

  div {
    ${tw`absolute rounded-half`}
  }
`;

export const Circle1 = styled.div`
  ${tw`h-16 w-16 bg-blueClr opacity-30`};

  left: 5%;
  top: 10%;
  animation: zoomInOut 8s linear infinite;
`;

export const Circle2 = styled.div`
  ${tw`h-20 w-20 bg-primaryClr opacity-40`};

  left: 30%;
  top: 50%;
  animation: bounceTop 5s ease-in-out infinite;
`;

export const Circle3 = styled.div`
  ${tw`h-32 w-32 bg-white opacity-60`};

  right: -60px;
  top: 40%;
`;

export const Circle4 = styled.div`
  ${tw`h-12 w-12 bg-orangeClr opacity-60`};

  left: -30px;
  top: 80%;
`;
